export const addDeviceResolutionToImageURLParams = (url: string) => {
    try {
        // Instantiating a new URL object instance with a bad or empty URL will
        // throw an error. We do not want our components to puke and crash the
        // app so we will handle it gracefully if the url is invalid.
        const newURL = new URL(url);

        newURL.searchParams.append('height', window.innerHeight.toString());
        newURL.searchParams.append('width', window.innerWidth.toString());

        return newURL.toString();
    } catch (e) {
        // Return the original url if we fail to append the necessary search
        // params for iris to operate on.
        return url;
    }
};
